<template>
  <QHeader>
    <QToolbar
      class="h-16 dark:bg-dark-1 light:bg-light-1 md:px-1/10 relative"
    >
      <QBtn
        v-if="!configStore.leftDrawerOpen && $q.screen.gt.sm"
        flat
        dense
        icon="menu"
        aria-label="Menu"
        class="h-10 w-10 absolute left-2 dark:(text-dark-text bg-dark-1) light:(text-light-text bg-light-3)"
        @click="configStore.toggleLeftDrawer()"
      />
      <div class="w-full flex items-center justify-between">
        <div
          v-if="$q.screen.lt.md"
          class="flex flex-nowrap items-center gap-2"
        >
          <QBtn
            flat
            dense
            icon="menu"
            aria-label="Menu"
            class="h-10 w-10 dark:(text-dark-text bg-dark-1) light:(text-light-text bg-light-3)"
            @click="configStore.toggleLeftDrawer()"
          />
          <Logo
            class="w-30"
            clickable
            :dark="$q.dark.isActive"
          />
        </div>
        <AppNav v-if="$q.screen.gt.sm" />
        <UserNav />
      </div>
    </QToolbar>
  </QHeader>
</template>

<script setup>
import AppNav from './AppNav.vue'
import UserNav from './UserNav.vue'
import Logo from '@/components/Logo.vue'
import {useConfigStore} from "@/stores/config";

const configStore = useConfigStore()
</script>
